module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Regular.ttf?ffc0d6297309ba52bb9500c00f71a4c3";